import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "roles-viewer" }
const _hoisted_2 = { class: "rest" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Role = _resolveComponent("Role")
  const _component_Tooltip = _resolveComponent("Tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.c_roles.visible, (role) => {
      return (_openBlock(), _createBlock(_component_Role, {
        key: role,
        type: role
      }, null, 8 /* PROPS */, ["type"]))
    }), 128 /* KEYED_FRAGMENT */)),
    ($options.c_roles.rest.length)
      ? (_openBlock(), _createBlock(_component_Tooltip, {
          key: 0,
          text: $options.more_text
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString($options.c_roles.rest.length) + " more... ", 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["text"]))
      : _createCommentVNode("v-if", true)
  ]))
}